<ng-container *transloco="let t">
  <div class="paywall-modal">
    <div
      class="paywall-backdrop"
      role="button"
      tabindex="0"
      (click)="notNow()"
      (keydown.enter)="notNow()"
      (keydown.space)="notNow()"></div>
    @if (!upgradeUnavailable) {
      <div
        class="paywall-sheet"
        tabindex="0"
        (click)="$event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()">
        @if (paywallRendered) {
          <button type="button" class="paywall-close-button" aria-label="Close paywall" (click)="notNow()">
            <span aria-hidden="true">&times;</span>
          </button>
        }
        @if (error) {
          <div class="error">{{ error }}</div>
        }
        <div class="paywall-container" [class.paywall-visible]="paywallStarted" #paywallContainer></div>
      </div>
    } @else {
      <div
        class="paywall-modal-card-host"
        tabindex="0"
        (click)="$event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()">
        <div class="upgrade-unavailable-content">
          <h2 id="upgrade-unavailable-title">{{ t('Upgrade unavailable') }}</h2>
          <p>{{ t("We couldn't load upgrade options right now. Please try again later.") }}</p>
          <button
            type="button"
            class="button button-pill button-reverse button-modal"
            (click)="acknowledgeUpgradeUnavailable()">
            {{ t('OK') }}
          </button>
        </div>
      </div>
    }
  </div>
</ng-container>
